import React from 'react'
import { getLinkSteps } from '../utils/helpersAdmin'

const quickSearchSteps = [
  {
    label: 'Página de consulta',
    hint: 'Configura y agrega la información necesaria para tu página de consulta.'
  },
  {
    label: 'Resultados de la consulta',
    hint: (
      <>
        <p className="mb-4">Determina las respuestas que se mostrarán a las personas que usen la consulta rápida.</p>
        <ol className="list-decimal ml-5">
          <li>Indica si quieres incluir información de contacto de tu entidad en los resultados.</li>
          <li>Carga la base de datos con tus resultados, en base al archivo de ejemplo.</li>
          <li>Crea las respuestas que se ofrecerán a las personas.</li>
        </ol>
      </>
    )
  },
  {
    label: 'Vista previa y publicación',
    hint: 'Revisa tu página de consulta, publícala y comparte el enlace con tus usuarios.'
  }
]

const options = {
  documentType: [
    { label: 'DNI', value: 'dni', pronoun: 'el ' },
    { label: 'Pasaporte', value: 'passport', pronoun: 'el ' },
    { label: 'Carné de extranjería', value: 'inmigration_cart', pronoun: 'el ' },
    { label: 'Permiso temporal de permanencia', value: 'temporary_permision', pronoun: 'el ' },
    { label: 'Cédula de identidad', value: 'identity_card', pronoun: 'la ' },
    { label: 'Otro documento', value: 'other_document' }
  ],

  validation: [
    { label: 'Sin dato de validación', value: 'none' },
    { label: 'Fecha de nacimiento', value: 'birth_date' }
  ],

  contact: [
    {
      label: 'Quiero que los datos de contacto aparezcan en las páginas de resultados.',
      value: 'contact'
    }
  ],
  colSeparator: [
    { label: 'Coma (,)', value: 'comma' },
    { label: 'Punto y coma (;)', value: 'semicolon' }
  ]
}

const headerInfo = name => ({
  new: {
    title: 'Crear consulta rápida',
    hint: 'Crear una página de consulta rápida para tu institución.'
  },
  edit: {
    title: `Editando consulta rápida: ${name}`,
    hint: 'Editar una página de consulta rápida para tu institución.'
  }
})

const getSpreadsheetPath = validationType =>
  validationType === 'none'
    ? '/Formato de Consulta Rapida sin validacion.csv'
    : '/Formato de Consulta Rapida con validacion.csv'

const getLabelResult = index => {
  if (index === 0) return 'Respuesta para números consultados que no está en la base de datos (obligatorio)'
  const initialIndex = 64
  const letterOfIndex = String.fromCharCode(initialIndex + index)
  return `"${letterOfIndex}"`
}

const getLabelDocumentType = (documentType, otherDocumentLabel, isQuickSearchResult) => {
  if (otherDocumentLabel) return otherDocumentLabel
  const documentTypeLabel = options.documentType.find(doc => doc.value === documentType)
  return isQuickSearchResult ? `${documentTypeLabel.pronoun} ${documentTypeLabel.label}` : documentTypeLabel.label
}

const getWelcomeMessage = (citizenFullName = 'nombre del ciudadano') => {
  return `Hola, ${citizenFullName || ''}`
}

const getPageDescription = ({
  canFilterByInstitution,
  canFilterByBranchOffice,
  canFilterAndHasNotBranchOffices,
  canSeeBranchRecords
}) => {
  if (canFilterByInstitution) return 'Selecciona la entidad cuyas consultas rápidas quieres ver.'

  if (canFilterByBranchOffice) return 'Selecciona la sede cuyas consultas rápidas quieres ver.'

  if (canFilterAndHasNotBranchOffices) return 'Estas son las consultas rápidas creadas en tu institución.'

  if (canSeeBranchRecords) return 'Estas son las consultas rápidas creadas en tu sede.'

  return 'Estas son las consultas rápidas a las que tienes acceso.'
}

const getEditLinkSteps = (id, indexToIgnore) =>
  getLinkSteps(indexToIgnore, [
    `/consultas-rapidas/${id}/editar`,
    `/consultas-rapidas/${id}/resultados`,
    `/consultas-rapidas/${id}/vista-previa`
  ])

export {
  quickSearchSteps,
  options,
  getLabelResult,
  getLabelDocumentType,
  getWelcomeMessage,
  headerInfo,
  getSpreadsheetPath,
  getPageDescription,
  getEditLinkSteps
}
